import { defaultSessionSampleRate } from './const';
import { isCurrentSessionInSample } from 'owa-analytics/lib/utils/getSessionSampleBucket';
import { Config } from 'owa-fps-types';
import onTabVisibilityChanged from './onTabVisibilityChanged';
import trackFps from './trackFps';
import addOnVisibilityChangedListener from './utils/addOnVisibilityChangedListener';

export default function startTrackingFps(config?: Config) {
    const sampleRate = (config && config.sampleRate) || defaultSessionSampleRate;
    if (isCurrentSessionInSample(sampleRate)) {
        addOnVisibilityChangedListener(onTabVisibilityChanged);
        trackFps(config);
    }
}
